<template>
    <section>
        <div class="hotlead-panel">
            <div class="hotlead-photo">
                <img loading="lazy" :alt="dpp.geo.formatAddress" :title="dpp.geo.formatAddress" :src= "dpp.tnImgPath" v-if="dpp.photoCount > 0">
                <mvtMapStatic class="img" :lat="dpp.geo.lat" :cacheFirst="true" :lng="dpp.geo.lng" type="streetview" streetViewDefautType="satellite" :address="dpp.geo.formatAddress" :markers="staticMapData.markers" :height="staticMapData.height" v-else></mvtMapStatic>
            </div>
            <div class="inline bg-default large" :class="{'hotlead-inline-rentals': dpp.isRentals}">
                <div>
                    <mvtHotleadForm v-show="hotleadOpt" :options="hotleadOpt" :assignedAgent="assignedAgent" />
                </div>
            </div>
        </div>
        <div class="paragraph f7" v-show="showNotSupportedByMLS()">
            {{molang('dpp.notProvidedMLS')}}
        </div>
    </section>
</template>

<script src="./property-inlinehotlead.js"></script>

<style lang="scss">
@use "./property-inlinehotlead.scss" as *;
</style>
